import { ACTIVITY_MARK, ACTIVITY_RESET } from '../constants/actionTypes';

export const markActivity = (type = 'activity') => ({
	type: ACTIVITY_MARK,
	payload: {
		type,
		time: new Date(),
	},
});

export const resetActivity = () => ({
	type: ACTIVITY_RESET,
});



// WEBPACK FOOTER //
// ./src/actions/activity.js